import { put, call, takeLatest } from "redux-saga/effects";
import * as Actions from "us.collection.economy/actions";
import * as API from "us.collection.economy/services";
import { RemitDetails } from "us.collection.economy/constants/Actions";
import { addIdsToRecords } from "us.collection.economy/functions/RemitDetails";
const { postRemitDetails } = Actions;
const { getRemitDetails } = API.remitDetails;

const RemitDetailsSagas = {
  remitDetails: {
    get: function* (action: any) {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(getRemitDetails.get, params);
       if(status == 200 || status == 204){
          yield put(postRemitDetails.remitDetail.success(addIdsToRecords(data)));
       }else{
         yield put(postRemitDetails.remitDetail.fail(new Error()));
       }
      } catch (error) {
        yield put(postRemitDetails.remitDetail.fail(new Error()));
      }
    },
  },
};

export default [
  takeLatest(
    RemitDetails.GET_REMIT_DETAILS,
    RemitDetailsSagas.remitDetails.get
  ),
];
